<!-- ROOT DEL DASHBOARD (para Guided Tour) -->
<div data-tour="dashboard-root">

  @switch (userRole) {

    @case (UserRole.Medico) {
      <app-patient-list
        [control]="control"/>
    }

    @case (UserRole.Admin) {
      <app-users
        [control]="control"/>
    }

    @case (UserRole.Responsable_Farmacia) {
      <app-users
        [control]="control"/>
    }

    @case (UserRole.Supervisor_Sucursales) {
      <app-users
        [control]="control"/>
    }

    @case (UserRole.Paciente) {
      <app-patient-my-prescriptions/>
    }

  }

</div>
